module.exports = __webpack_public_path__ + "static/img/logo06.687b497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo06.png
// module id = 2YmH
// module chunks = 1